import React from 'react'
import { PolicyLayout } from '../../shared/PolicyLayout'
import { P } from '../../shared/P'
import Footer from '../components/Footer'

export default function Shipping() {
  return <><PolicyLayout title="Delivery Policy" icon="🚀" sub="Fast, fresh and reliable">
  <P title="Delivery Areas">Currently serving all of Hyderabad including Banjara Hills, Jubilee Hills, Hitech City, Gachibowli, Secunderabad and 50+ more areas. Enter your PIN to check availability.</P>
  <P title="Delivery Times">Standard: 25–35 minutes · Express (select areas): 15–20 minutes · Pre-scheduled: Up to 3 days in advance with 30-min slots</P>
  <P title="Delivery Fees">Orders above $30: FREE · $15–$30: $1.99 · Below $15: $3.99 · Express surcharge: $2.00</P>
  <P title="Live Tracking">Track your order in real time via our app from the moment you place it. You'll see: Received → Preparing → Out for Delivery → Delivered</P>
  <P title="Failed Deliveries">If you're unreachable after 2 attempts, the order is held for 10 minutes then returned. A partial refund (minus delivery costs) is issued automatically.</P>
</PolicyLayout>
 <Footer />
  </>
}
